import { decryptData } from "config/config";
import React, { useState } from "react";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import eye from "assets/icons/eye.png";
import SuperTag from "components/SuperTag/SuperTag";
import Drawer from "components/drawer/Drawer";
import { convertToRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";
import { fixedImageDimension } from "utils";
import './TextEditor.css'

const TextEditor = ({
  value,
  onChange,
  label,
  style,
  error,
  required,
  maxLength,
  ...rest
}) => {
  const [drawerState, setDrawerState] = useState(false);
  const [editorData, setEditorData] = useState("");

  // image upload function
  function uploadImageCallBack(file) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest(); // eslint-disable-line no-undef
      xhr.open("POST", `${process.env.REACT_APP_API_URL}/master/upload/image`);
      // xhr.setRequestHeader("Authorization", "Client-ID 8d26ccd12712fca");
      const data = new FormData(); // eslint-disable-line no-undef
      data.append("image", file);
      xhr.send(data);
      xhr.addEventListener("load", () => {
        const response = JSON.parse(xhr.responseText);
        const imageUrl = decryptData({ data: response })?.data?.imageUrl;

        resolve({ data: { link: imageUrl } });
      });
      xhr.addEventListener("error", () => {
        const error = JSON.parse(xhr.responseText);
        reject(error);
      });
    });
  }

  const viewHandler = () => {
    setDrawerState(true);
    setEditorData(
      fixedImageDimension(draftToHtml(convertToRaw(value.getCurrentContent())))
    );
  };



  return (
    <div>
      {label && <label className="my-1">{label}</label>}
      {required && <span className="text-danger"> *</span>}
      <Editor
        editorState={value}
        wrapperClassName="demo-wrapper"
        editorClassName={`text-editor-section ${error && "is-invalid"}`}
        onEditorStateChange={onChange}
        placeholder={"Description"}
        {...rest}
        toolbar={{
          image: {
            urlEnabled: true,
            uploadEnabled: true,
            alignmentEnabled: true,
            previewImage: true,
            inputAccept: "image/gif,image/jpeg,image/jpg,image/png,image/svg",
            uploadCallback: uploadImageCallBack,
            alt: { present: true, mandatory: false },
            defaultSize: {
              height: "250",
              width: "250",
            },
          },
        }}
        toolbarCustomButtons={[
          <div
            className="rdw-image-wrapper"
            aria-haspopup="true"
            aria-expanded="false"
            aria-label="rdw-image-control"
            onClick={viewHandler}
          >
            <div className="rdw-option-wrapper" title="View">
              <img src={eye} alt="view" width={"18"} />
            </div>
          </div>,
        ]}
      />
      {error && (
        <div className="text-danger" style={{ fontSize: "0.875em" }}>
          {error}
        </div>
      )}

      <Drawer
        open={drawerState}
        onClose={() => setDrawerState(false)}
        title={"View Editor"}
        size="full"
        position="bottom"
      >
        <SuperTag>{editorData}</SuperTag>
      </Drawer>
    </div>
  );
};

export default TextEditor;
